import { WebviewerCreatedByRole, WebViewerModificationDataContainer } from "./webviewer-data.model";

export const CA_WEBVIEWER_APP_ORIGIN = window.location.origin;
export const CA_WEBVIEWER_APP_URL = `${CA_WEBVIEWER_APP_ORIGIN}/caWebViewer/index.html`;
export const WEB_VIEWER_SOURCE = "web-viewer";

export type WebViewerMessage =
	| WebViewerMessageInitialized
	| WebViewerMessageLoadingFinished
	| WebViewerMessageSubmitModification
	| WebViewerMessageCancelledModification
	| WebViewerMessageModificationChanged;

export type WebViewerMessageInitialized = {
	source: "web-viewer";
	type: WebViewerMessageType.INITIALIZED;
	payload: {
		version: string;
	};
};

export type WebViewerMessageLoadingFinished = {
	source: "web-viewer";
	type: WebViewerMessageType.LOADING_FINISHED;
	payload: {
		entityId?: string;
		referenceId?: string;
		mediaId?: string;
	};
};

export type WebViewerMessageSubmitModification = {
	source: "web-viewer";
	type: WebViewerMessageType.SUBMIT_MODIFICATION;
	payload: WebViewerModificationDataContainer;
};

export type WebViewerMessageCancelledModification = {
	source: "web-viewer";
	type: WebViewerMessageType.CANCELLED_MODIFICATION;
	payload: any;
};

export type WebViewerMessageModificationChanged = {
	source: "web-viewer";
	type: WebViewerMessageType.MODIFICATION_CHANGED;
	payload: {
		type: "comments_changed";
		comments: {
			comment: string;
			timestamp: string;
			createdByRole: WebviewerCreatedByRole;
			marker: string;
			object: string;
		}[];
	};
};

export enum WebViewerMessageType {
	INITIALIZED = "initialized",
	LOADING_FINISHED = "loading_finished",
	SUBMIT_MODIFICATION = "submit_modification",
	CANCELLED_MODIFICATION = "cancelled_modification",
	MODIFICATION_CHANGED = "modification_changed",
}

export enum WebViewerApiCommand {
	CANCEL_MODIFICATION = "cancel_modification",
	ENTER_MODIFICATION_MODE = "enter_modification_mode",
	LOAD_MODIFICATION = "load_modification",
	SUBMIT_MODIFICATION = "submit_modification",
}

export type WebViewerApiCommandMessage = {
	command: WebViewerApiCommand;
	payload?: any;
};

export type WebViewerApiCommandLoadModification = {
	command: WebViewerApiCommand.LOAD_MODIFICATION;
	options?: {
		append?: boolean;
	};
	payload: WebViewerModificationDataContainer;
};

export type WebViewerApiCommandEnterModificationMode = {
	command: WebViewerApiCommand.ENTER_MODIFICATION_MODE;
	payload?: {
		role?: WebviewerCreatedByRole;
		isSetupOnly?: boolean;
		isNewModification?: boolean;
	};
};

export type WebViewerApiCommandCancelModification = {
	command: WebViewerApiCommand.CANCEL_MODIFICATION;
	options?: {
		skipConfirmation?: boolean;
	};
};

export type WebViewerApiCommandSubmitModification = {
	command: WebViewerApiCommand.SUBMIT_MODIFICATION;
	options?: {
		skipConfirmation?: boolean;
	};
};

export function isWebviewerMessage(event: MessageEvent): event is MessageEvent<WebViewerMessage> {
	return (
		event.origin === CA_WEBVIEWER_APP_ORIGIN &&
		event.data.source === WEB_VIEWER_SOURCE
	);
}
